import { PlacesType, Tooltip as ReactTooltip } from 'react-tooltip'

import styles from './Tooltip.module.scss'
import classNames from 'classnames'

type TooltipProps = {
  tooltipContent: React.ReactNode
  tooltipId: string
  children: React.ReactNode
  isOpen: boolean
  className?: string
  position?: PlacesType
  arrowSize?: number
  arrowClassName?: string
}

export const Tooltip = ({
  children,
  tooltipContent,
  position,
  tooltipId,
  isOpen,
  className,
  arrowSize,
  arrowClassName
}: TooltipProps) => {
  return (
    <div className={styles.tooltipWrapper}>
      <div data-tooltip-id={tooltipId}>{children}</div>
      <ReactTooltip
        arrowSize={arrowSize}
        id={tooltipId}
        openEvents={{focus: true}}
        isOpen={isOpen}
        classNameArrow={arrowClassName}
        place={position}
        className={classNames(styles.tooltip, className)}
        border="1px solid rgb(217, 217, 217,0.3)"
      >
        {tooltipContent}
      </ReactTooltip>
    </div>
  )
}
